<td>
    <ng-container
            *ngIf="product.hasVariant(1281) || product.hasVariant(1339)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill=orange
             class="bi bi-star-fill" viewBox="0 0 16 16">
            <path
                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
        </svg>
    </ng-container>
</td>
<td>
    <i class="me-1  text-warning fas fa-bell" *ngIf="product?.price_adjustment?.is_notification_only"
       ngbTooltip="Kun overvågning"></i>
    <i class="me-1  text-warning fas fa-pause" *ngIf="product?.price_adjustment?.is_paused"
       ngbTooltip="Pause"></i>
    <i class="me-1  text-danger  fa  fa-exclamation" *ngIf="product.hasError()" ngbTooltip="Url fejl"></i>

    <span [ngClass]="{
                    'text-danger': !product.price_adjustment?.active && !product.price_adjustment?.is_campaign,
                    'text-success':product.price_adjustment?.active && !product.price_adjustment?.is_campaign,
                    'text-primary': product.price_adjustment?.is_campaign
                    }">
                        <i class="fas fa-check " *ngIf="product.price_adjustment?.active"
                           ngbTooltip="Price adjustment active"></i>
                        <i class="fas fa-ban" *ngIf="!product.price_adjustment?.active"
                           ngbTooltip="Price adjustment not active"></i>
                        <span *ngIf="product.price_adjustment?.is_campaign" class="ms-1 fas fa-info-circle"
                              ngbTooltip="Kampagne: {{product.price_adjustment.campaign_name}}"></span>
                    </span>
</td>
<td>
                      <span [ngClass]="{
                    'text-danger': !product.is_active,
                    'text-success': product.is_active
                    }">
                    <i class="fas fa-check " *ngIf="product.is_active" ngbTooltip="Product active on web"></i>
                    <i class="fas fa-ban" *ngIf="!product.is_active" ngbTooltip="Product not active on web"></i>
                      </span>
</td>
<td>{{product.external_reference}}</td>
<td style="max-width: 155px">
    <div *ngIf="product.name !== null; else none">
        <a [routerLink]="'/price-robot/product/' + product.id">{{product.name}}</a>
        <i class="ms-1  fa  fa-sticky-note" *ngIf="product.description"
           ngbTooltip="{{ product.description }}"></i>
        <i (click)="showImage(product.image_url)" class="ms-1  fa  fa-image" style="cursor: pointer;"></i>
    </div>
</td>
<td class="text-end">
    <p *ngIf="product.prices.length > 0; else none">
        {{product.prices[0].price | number:'1.2-2':'da'}}<br/>
        <small class="text-black-50" *ngIf="product.prices[0].modified && product.prices[0].modified.isValid()">{{product.prices[0].modified.format('YYYY-MM-DD')}}</small>
    </p>
</td>

<td class="text-end">
    <p *ngIf="product?.price_adjustment?.price">
        {{product?.price_adjustment?.price | number:'1.2-2':'da'}}<br/>
        <small class="text-black-50" *ngIf="product.price_adjustment.last_changed && product.price_adjustment.last_changed.isValid()">{{product.price_adjustment.last_changed.format('YYYY-MM-DD HH:ss')}}</small>

    </p>
</td>
<td class="text-end">
    <p *ngIf="product?.price_adjustment?.shipping_cost">
        {{product?.price_adjustment?.shipping_cost | number:'1.2-2':'da'}}
    </p>
    <p *ngIf="!product?.price_adjustment?.shipping_cost">{{0 | number:'1.2-2':'da'}}</p>
</td>

<td class="text-end">
    <p *ngIf="product?.price_adjustment?.costprice_2">
        {{product?.price_adjustment?.costprice_2 * 1.25 | number:'1.2-2':'da'}}
    </p>
</td>

<td class="text-end text-nowrap">
    <p *ngIf="product?.price_adjustment?.minium_margin">
        {{product?.price_adjustment?.minium_margin | number:'1.2-2':'da'}} %
    </p>
</td>
<td class="text-end">
    <p *ngIf="product?.price_adjustment?.minimum_price">
        {{product?.price_adjustment?.minimum_price | number:'1.2-2':'da'}}
    </p>
</td>

<td class="text-end">
    <p *ngIf="product.crawler_urls_count !== null; else noUrls">
        {{product.crawler_urls_count}}
    </p>
    <ng-template #noUrls>
        <p>0</p>
    </ng-template>
</td>

<td>
    <ng-container *ngIf="product.results && product.results.length > 0">
        <a [href]="product.results[0].url" target="_blank">
            {{product.results[0].crawler_website.name}}<br/>
        </a> Pris: <span
            *ngIf="product.results[0].last_measurement.price > 0"> {{product.results[0].last_measurement.price | number:'1.2-2':'da' }}</span><br/>
        Fragt: <span
            *ngIf="product.results[0].last_measurement.delivery > 0"> {{product.results[0].last_measurement.delivery | number:'1.2-2':'da'}}</span>
    </ng-container>
</td>
<td>
                    <span *ngIf="product.findIndex('salgsenhed') >= 0; else none">
                        {{product.custom_fields[product.findIndex('salgsenhed')].value}}
                    </span>
</td>
<td>
            <span *ngIf="product?.price_adjustment?.note === 'IKKE AKTIV IDA'"
                  style="color: red">{{product.price_adjustment?.note}}</span>
    <span *ngIf="product?.price_adjustment?.note !== 'IKKE AKTIV IDA'" class="d-flex flex-column">
                        <span *ngIf="product?.price_adjustment?.competitor_diff > 0" style="color: green">10-4 er billigst</span>
                        <span *ngIf="product?.price_adjustment?.competitor_diff < 0" style="color: red">10-4 er ikke billigst</span>

                        <span>{{product?.price_adjustment?.note}}</span>
                          <span><a href="{{product?.price_adjustment?.competitor_data?.crawler_url?.url}}">
                              Konkurrent: {{product?.price_adjustment?.competitor_data?.crawler_website?.name}}
                          </a>
                          </span>

                                <ng-container *ngIf="
product?.price_adjustment &&
product?.price_adjustment.competitor_data &&
product?.price_adjustment.competitor_data.actions_applied_data
">
                                    <div>
<!--                                                               <span> Rules: {{product?.price_adjustment?.competitor_data?.actions_applied}} </span>-->
                                    <ng-container
                                            *ngFor="let data of product?.price_adjustment?.competitor_data?.actions_applied_data">
                                        <span class="badge rounded-pill text-white bg-primary me-1">
                                            {{data.name}}</span>
                                    </ng-container>
                                    </div>
                                </ng-container>
                           <span> Mindste konkurrentpris: {{product?.price_adjustment?.minimum_competitor_price | number:'1.2-2':'da'}}</span>
                    </span>
</td>

<td class="text-end">
    <ng-container *ngIf="product?.price_adjustment?.deviation_pct">
        {{product?.price_adjustment?.deviation_pct | number:'1.2-2':'da'}} %
    </ng-container>
</td>
<td>
    <p *ngIf="product.variants[0] !== undefined; else none">
        {{product.variants[0].name}}
    </p>
</td>
<td>
    <ng-container *ngIf="product.users.length > 0; else none">
                        <span *ngFor="let user of product.users" class="badge rounded-pill bg-secondary me-1">
                            {{user.name}}
                        </span>
    </ng-container>
</td>

<ng-template #none>
    <p style="color: grey;">
        Ingen
    </p>
</ng-template>
